import React from 'react'
import BaseQueryControlComponent from './BaseQueryControlComponent'
import Immutable from 'immutable'
import {makeGrids, getFieldWidthClass} from '../../helpers/makeGrids.js'
import FieldComponent from './FieldComponent'
import {Button} from 'react-bootstrap'
import {t} from '../../helpers/translate'
import {isAgent, isMGA, isGroupAdmin, isAdmin, isSchoolAdmin, isViewonly} from '../../helpers/access'
import _ from 'lodash';
import $ from 'jquery';
let config = require('config');

class SearchboxComponent extends BaseQueryControlComponent {

  itemsPerRow = 2;

  constructor(props) {
    super(props);
    this.state = {
      sources: props.sources || ['all'],
      data: Immutable.Map(this.props.criteria)
    }
  }

  handleDataChange(delta) {
    if (delta.key_path[0] == 'insurer'){
        this.props.setInsurer(delta.value);
    }

    this.setState({
       data: this.state.data.setIn(delta.key_path, delta.value)
    })
  }

  updateOptions(savedOptionsState, options){
    this.setState({[savedOptionsState]: options})
  }

  getSavedOptions(savedOptionsState){
    return this.state[savedOptionsState];
  }

  fieldRenderer (field,index){
    return <div key={index} className={getFieldWidthClass(field, this.itemsPerRow)} >
              <label className='text-uppercase'>{t(field.as)}</label>
              <FieldComponent
                type={field.type}
                keyPath={[field.key]}
                format={field.format}
                onDataChanged={this.handleDataChange.bind(this)}
                minDate={field.min_date}
                maxDate={field.max_date}
                options={field.options}
                optionsUrl={field.options_url}
                savedOptionsState={field.saved_options_state}
                updateOptions={this.updateOptions.bind(this)}
                getSavedOptions={this.getSavedOptions.bind(this)}
                id={`${field.key}`}
                hideNullOption={field.hideNullOption}
                defaultValue={field.defaultValue}
                {...this.state}
              />
            </div>;
  }

  fill() {
    const searchParameters = config.default.search[this.props.searchType][sessionStorage.getItem('org')];
    const fields = [];

    for (let param of searchParameters) {

      if (isAgent() && !isMGA() && ['tracking_code'].includes(param.key)) {
        continue;
      }

      if ((this.props.searchType == 'report') && !isAdmin() && ['user_scope', 'first_name', 'last_name'].includes(param.key)) {
        continue;
      }

      if (isAgent('ingle') && ['sources', 'insurer'].includes(param.key)) {
        continue;
      }

      if ((isGroupAdmin() || isSchoolAdmin() || isViewonly()) && ['tracking_code', 'insurer'].includes(param.key)) {
        continue;
      }
      
      if (param.key == 'sources') {
        param.options = this.props.sources;
      }

      fields.push(param);
    }

    const elems = fields.map((field,index) => {
         return this.fieldRenderer(field,index);
      }
    );

    return makeGrids(
      this.itemsPerRow, 
      elems.filter((elem) => elem),
      true
    );
  }

  getCriteriaKeys() {
    return config.default.search[this.props.searchType][sessionStorage.getItem('org')].map((field) => field.key)
  }

  submitText() {
    let data = this.state.data.toObject()

    if ((data.sources == undefined) && (this.props.searchType == 'applicant')){
      data.sources = 'all';
    }

    let query = this.getUpdatedQuery(data, this.getCriteriaKeys());
    query.page = 1;
    delete query.orderby;
    delete query.order;
    this.updateSearchString(query);
  }

  getCleanedObject(object) {
    let keys = this.getCriteriaKeys();
    let inputs = $('#criteria-form').find('input[type=text]');
    let values = inputs.toArray().map((input) => input.value);
    for (let i = 0; i < inputs.length; i++) {
      if (_.isEmpty(values[i])) {
        delete object[keys[i]]
      }
    }
    return object;
  }

  render() {
    return <div id="criteria-form">
      {this.fill()}
      <br />
      <div className="div-center">
        <Button className={`btn btn-lg button-secondary ${isAgent('ingle') && 'primary-btn-color'}`} onClick={this.submitText.bind(this)}>{t('Search')}</Button>
      </div>
    </div>
  }
}
SearchboxComponent.displayName = 'SearchboxComponent';
export default SearchboxComponent;



// WEBPACK FOOTER //
// ./src/components/common/SearchboxComponent.js